// extracted by mini-css-extract-plugin
export default {"headerContainer":"actions_headerContainer__imIsZ","cost":"actions_cost__-U0hZ","resendDiv":"actions_resendDiv__l08O7","timer":"actions_timer__FYGy5","badge":"actions_badge__+14BJ"};